module.exports = __webpack_public_path__ + "media/Video 130.e9cf9524.mp4";